import { combineReducers } from 'redux';
import zipcodeCheck from './zipcodeCheck';
import enquiry from './enquiry';
import user from './user';
import Login from './Login';
import email from './email';
import historicalDataReducer from './historicalData';
import ForgotPwd from './ForgotPassword';
import priceList from './priceList';
import pricingCalc from './pricingCalculator';
import orderSubmit from './Order/PlaceOrder'
import updateOrder from './Order/UpdateOrder';
import NotificationList from './UserAccount/getNotificationList';
import DogList from './UserAccount/getDogList';
import AccountInfo from './UserAccount/getAccountinfo';
import updatedDog from './UserAccount/updateDog';
import addedDog from './UserAccount/addDog';
import deletedPets from './UserAccount/deletePets';
import serviceOrder from './UserAccount/getServiceOrder';
import updatedUser from './UserAccount/updateUser';
import updatedNotification from './UserAccount/updateNotification';
import getMessages from './UserAccount/getMessages';
import getReasons from './UserAccount/getReasons';
import createdMessage from './UserAccount/createNewTicket';
import messageReply from './UserAccount/messageReply';
import ticketClosed from './UserAccount/closeTicket';
import getCard from './UserAccount/getCardList';
import newCard from './UserAccount/addNewCard';
import updatedCard from './UserAccount/updateCard';
import BillingInfo from './UserAccount/getBillingInfo';

import PreferredDays from './getPreferredDays';

import cardDeleted from './UserAccount/deleteCard';
import messageCount from './UserAccount/getMessageCount';
import commercialQuote from './commercial';

import viewMyService from './UserAccount/getViewMyservice';
import servicePause from './UserAccount/pauseService';
import pauseServiceList from './UserAccount/getPauseService';
import pauseServiceDeleted from './UserAccount/deletePauseService';
import UPASTService from './UserAccount/getUpcomingService';
import addReview from './UserAccount/addReview';
import addBag from './UserAccount/addBag';
import ServiceStats from './UserAccount/serviceStats'

import resetPWD from './ResetPassword';
import GetInvoice from './UserAccount/getInvoice';
import ResRegister from './ResidentialRegister';
import GetProposal from './UserAccount/getProposal';
import CustomerStep from './stepTracking';

// Commerical
import GetCommercialInfo from './Commercial/getUserInfo';
import UpdateCommercialUser from './Commercial/updateUserInfo';
import CommunityInfo from './Commercial/getCommunityInfo';
import UpdateCommunity from './Commercial/updateCommunity';
import GetPayment from './Commercial/getPayment';
import DownloadInvoice from './UserAccount/PrintInvoice';

// Google Api
import GoogleApi from './GoogleApi';

// Payment Link
import PaymentReducer from './pay'
import zipcodeReducers from './zipcodeCheck';

export default combineReducers({
  zipcodeCheck,
  user,
  email,
  historicalDataReducer,
  Login,
  ForgotPwd,
  enquiry,
  priceList,
  pricingCalc,
  orderSubmit,
  updateOrder,
  NotificationList,
  DogList,
  AccountInfo,
  updatedDog,
  addedDog,
  deletedPets,
  serviceOrder,
  updatedUser,
  updatedNotification,
  getMessages,
  getReasons,
  createdMessage,
  messageReply,
  ticketClosed,
  getCard,
  newCard,
  cardDeleted,
  messageCount,
  commercialQuote,
  viewMyService,
  servicePause,
  pauseServiceList,
  pauseServiceDeleted,
  UPASTService,
  addReview,
  updatedCard,
  addBag,
  resetPWD,
  GetInvoice,
  ResRegister,
  GetProposal,
  GetCommercialInfo,
  UpdateCommercialUser,
  CommunityInfo,
  UpdateCommunity,
  GetPayment,
  DownloadInvoice,
  ServiceStats,
  PreferredDays,
  GoogleApi,
  BillingInfo,
  PaymentReducer,
  zipcodeReducers,
  CustomerStep
})